import { useNullableDealerAccountInfo } from "../../../../../stores/hooks/useNullableDealerAccountInfo";

type OriginalEquipmentSettings = {
  originalEquipmentOnly: "1" | "2";
  useOriginalEquipmentOnlyFilter: boolean;
  useOriginalEquipmentOnlyFilterWhenAuhenticated: boolean;
};

export const useOriginalEquipmentSettings = (): OriginalEquipmentSettings => {
  const dealer = useNullableDealerAccountInfo();

  switch (dealer?.dealerProductFilters.originalEquipmentFilter) {
    case "HIDE_ALL":
      return {
        originalEquipmentOnly: "2",
        useOriginalEquipmentOnlyFilter: false,
        useOriginalEquipmentOnlyFilterWhenAuhenticated: false,
      };
    default:
    case "HIDE_OE":
      return {
        originalEquipmentOnly: "1",
        useOriginalEquipmentOnlyFilter: false,
        useOriginalEquipmentOnlyFilterWhenAuhenticated: false,
      };
    case "ALL_ALL":
      return {
        originalEquipmentOnly: "2",
        useOriginalEquipmentOnlyFilter: true,
        useOriginalEquipmentOnlyFilterWhenAuhenticated: true,
      };
    case "ALL_OE":
      return {
        originalEquipmentOnly: "1",
        useOriginalEquipmentOnlyFilter: true,
        useOriginalEquipmentOnlyFilterWhenAuhenticated: true,
      };
    case "AUTH_ALL":
      return {
        originalEquipmentOnly: "2",
        useOriginalEquipmentOnlyFilter: false,
        useOriginalEquipmentOnlyFilterWhenAuhenticated: true,
      };
    case "AUTH_OE":
      return {
        originalEquipmentOnly: "1",
        useOriginalEquipmentOnlyFilter: false,
        useOriginalEquipmentOnlyFilterWhenAuhenticated: true,
      };
  }
};
